module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAKdJREFUSEvtllEOgCAMQ9eb6P0PpTepwWiigKCAVRP5H492GxtMfCDmWQAkOZhZV/iQEUCfio0BWQibwwAkXXsdsAcwbhWTdHY726OnVmExcKkFZ/Eup7dZSnKuBV/x64CBpX7i/JyuikoVyoGXW7JWoRwot1QOlFv6AwMHPtcWkhw2WTFO/6WXJR0ESIHbCZKdh5HxU2NxfgA3BgZr4/OLcKuiObpnAvPpwR0bpcXJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_order.png
// module id = zjs4
// module chunks = 1